<div class="date-input" [class.date-input--disabled]="disabled()" (click)="openCalendar(picker)" (keydown.enter)="openCalendar(picker)">
  <div class="date-input__inner">
    <input
      readonly
      class="date-input__field"
      [attr.aria-label]="'translations.global.ariaLabels.selectDate' | transloco"
      [placeholder]="'translations.global.ariaLabels.selectDate' | transloco"
      [value]="selectedDate()"
      [attr.data-value]="value()"
      [min]="minDate()"
      [max]="maxDate()"
      [disabled]="disabled()"
      [matDatepicker]="picker"
      (dateChange)="onDateChange($event.value)"
    />
    <ptl-icon class="date-input__icon" [icon]="LucideCalendar" [size]="'s'" [color]="'currentColor'"></ptl-icon>
  </div>
  <mat-datepicker #picker panelClass="ptl-v3-calendar"></mat-datepicker>
</div>
